/**
 * Product photography for the Products mega menu (desktop tiles, phone list thumbnails), plus the Help-card strip and the
 * Catalogue-card cover. The menu component contains no image URLs: replace a picture by editing its entry here (and, if it is
 * one of the six product cut-outs, by rerunning scripts/build-product-menu-images.py so the sizes match).
 *
 * Text (titles, descriptions, sub-product links) still comes from Admin → Mega Menu — this file only supplies imagery, keyed by the
 * category's slug, so editing copy or link order in the admin keeps working. A category that isn't listed here falls back to the
 * image saved in the admin.
 *
 * Every picture is a real Shingare product photograph, cut out and tightly cropped (nothing generated or redrawn). Provenance:
 *  tube-tool              BPC-5 electric tube cleaner — client-supplied studio photo (shingare.com/api/uploads/general/5a0c50530cb0d7151b51.png)
 *  bolting-tools          hydraulic torque wrench (SHINGARE) — client upload fb1c9151ab0e4f16b253.jpg; also the cover of the client's
 *                         "Hydraulic Torque Wrenches" catalogue PDF
 *  grinding-tools         flexible shaft grinder, motor + flexible shaft + grinding wheel — tubecleaner.co.in/assets/img/Flexible-Shaft-Grinder.jpg
 *  pipe-beveling-machine  portable pipe beveler on a pipe — client upload 3a9e085448a5f65c1d46.jpg
 *  spring-balancer        freeload balancer — client upload 24f8a84dff1c5ffc19e9.jpg
 *  tapping-tool           articulated-arm tapping machine — client upload 44ae6ccb1dc51e231b1f.jpg
 *  help card              images/company/tube-cleaning-services.webp (technician cleaning a heat-exchanger tube sheet)
 *  catalogue              images/resources/catalogues/pipe-beveling-machine.webp (cover of a real Shingare catalogue PDF)
 * Full write-up: public/images/menu/products/SOURCES.md.
 *
 * Sizes are the files' real pixel dimensions (from build manifest.json): they set width/height (no layout shift) and the srcset.
 */
const BASE = "/images/menu/products";

const entry = (slug, name, alt, full, sm, thumb) => ({
  slug,
  name,
  alt,
  href: `/products/${slug}`,
  image: {
    src: `${BASE}/${slug}.webp`,
    srcSet: `${BASE}/${slug}-sm.webp ${sm[0]}w, ${BASE}/${slug}.webp ${full[0]}w`,
    width: full[0],
    height: full[1],
  },
  thumb: { src: `${BASE}/thumbs/${slug}.webp`, width: thumb[0], height: thumb[1] },
});

export const productMenuVisualData = [
  entry("tube-tool", "Tube Tools", "Shingare BPC-5 electric tube cleaning machine with flexible shaft and foot switch", [326, 448], [146, 200], [105, 144]),
  entry("bolting-tools", "Torque Tools", "Shingare hydraulic torque wrench", [480, 356], [200, 148], [144, 107]),
  entry("grinding-tools", "Flexible Shaft Grinder", "Shingare flexible shaft grinder with motor, flexible shaft and grinding wheel", [411, 348], [200, 169], [144, 122]),
  entry("pipe-beveling-machine", "Pipe Beveling Machine", "Shingare portable pipe beveling machine mounted on a pipe", [265, 480], [110, 200], [79, 144]),
  entry("spring-balancer", "Spring Balancer", "Shingare freeload spring balancer with hook", [231, 377], [123, 200], [88, 144]),
  entry("tapping-tool", "Tapping Machine", "Shingare articulated-arm tapping machine on a cabinet base", [243, 408], [119, 200], [86, 144]),
];

const bySlug = new Map(productMenuVisualData.map((p) => [p.slug, p]));
export const visualForProductCategory = (slug) => bySlug.get(slug) || null;

/** Small real-application strip at the top of the "Need help choosing…" card. */
export const productMenuHelpVisual = {
  src: `${BASE}/help-card.webp`,
  width: 480,
  height: 209,
  alt: "Shingare technician cleaning a heat-exchanger tube sheet with a tube-cleaning lance",
};

/** Real Shingare catalogue cover for the catalogue card. */
export const productMenuCatalogueVisual = {
  src: `${BASE}/catalogue-cover.webp`,
  width: 216,
  height: 305,
  alt: "Cover of the Shingare Industries product catalogue",
};
